import React from 'react';

interface Props {
  isPremiumSupport: boolean;
}

const PremiumSupportBadge: React.FC<Props> = ({ isPremiumSupport }) => {
  const text = isPremiumSupport ? '土日祝日オプション適用中' : '土日祝日オプション適用外';
  const style: React.CSSProperties = {
    display: 'inline-block',
    padding: '4px 12px',
    border: '1px solid #fff',
    borderRadius: 0,
    fontSize: 12,
    fontWeight: 'bold',
    color: '#fff'
  };
  return <span style={style}>{text}</span>;
};

export default PremiumSupportBadge;
